import React, { useEffect, useState, useContext } from 'react';
import {  Icon, Segment, Table, Label, Grid, Header, HeaderSubheader } from 'semantic-ui-react'

import { ConnectWS } from '../../../../ConnectWS';
import AuthContext from '../../../../context/authContext';
import CountDownTimer from '../../countDownTimer/CountDownTimer';
import { changeFormatDate, changeFormatDateTimeBS, changeInitialScale, charTGToNumber, checkDateStartBeforeNow, checkTimeExist, getlinkplayerprofile, loadingShow, mobileWSmall } from '../../../../myfunctions';

import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import { useToasts } from 'react-toast-notifications';
import { useParams, } from "react-router-dom";
import MyTournamentAddUsersActivity from '../MyTournaments/MyTournamentAddUsersActivity';
import ShowImgAvatar from '../../../../tools/ShowImgAvatar';
import { useTranslation } from 'react-i18next'
import MyImageLazy from '../../../../tools/MyImageLazy';
import Lightbox from 'react-image-lightbox';
import noimage from '../../../../assets/noimage.png';
import { Markup } from 'interweave';

function ShowActivities(props) {
  const { addToast } = useToasts();
  const authContext = useContext(AuthContext);
  const [loading, setloading] = useState(true);
  const { width, height } = useWindowDimensions();// eslint-disable-line no-unused-vars
  const { activity_id } = useParams()
  const [rowDataJson, setrowDataJson] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    changeInitialScale(1)
    getActivitie(activity_id)
    return () => { }; // use effect cleanup to set flag false, if unmounted
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  function getActivitie(activity_id) {
    let activity_idt = charTGToNumber(activity_id)
    setloading(true)
    ConnectWS("/activity/getActivity", authContext.token, { activity_id: activity_idt }, function (response, logout) {

      if (logout === 1) {
        addToast('Zaraz nastapi wylogowanie: ' + response.error, { appearance: 'error' });

      } else if (response && response.status && Number(response.status) === 200) {

        setrowDataJson(response.data)

      } else {

        if (logout === 101) {
          addToast(response, { appearance: 'info' });
        } else if (logout === 102) {
          addToast(response, { appearance: 'warning' });
        } else {
          addToast(response, { appearance: 'error' });
        }
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 2000);
        //console.log(response);
      }
      setloading(false)


    });
  }

  function getCountColumn() {
    let cc = 4;
    if (rowDataJson && rowDataJson.organizer_phone) {
      cc++
    }
    if (rowDataJson && rowDataJson.organizer_email) {
      cc++
    }
    if (width < 400) {
      return 1
    }
    if (width < 950) {
      if (cc > 4) {
        return 3
      } else {
        return 2
      }
    }
    if (width < 1400 && cc > 4) {
      return 3
    }


    return cc
  }


  function checkIsDescription() {
    return rowDataJson && rowDataJson.description && rowDataJson.description.length > 1 && rowDataJson.description !== "<p><br></p>"
  }

  function checkIsPicture() {
    return rowDataJson && rowDataJson.img_file
  }

  const [photoIndex, setphotoIndex] = useState(0)
  const [isOpen, setisOpen] = useState(false)
  function openModal(id) {
    setisOpen(true)
    setphotoIndex(id)
  }

  return (
    loading ? loadingShow() :
      <div style={{ minHeight: height, paddingTop: 20, paddingBottom: 30, marginTop: -20, marginBottom: -20, paddingLeft: 15, paddingRight: 10 }} className={authContext.darkMode ? "bgDartTheme" : ""}>
  {isOpen && (
            <Lightbox
              mainSrc={photoIndex}
              onCloseRequest={() => setisOpen(false)}
            />
          )}
        <Segment >
          <Header as='h3' style={{ lineHeight: "20px" }} >
            <Icon name='info circle' />
            <Header.Content>
              {rowDataJson ? rowDataJson.activity_name : "?"}
            </Header.Content>
          </Header>
          <span style={{ fontSize: 14 }}>
            {rowDataJson && checkDateStartBeforeNow(rowDataJson.activity_stop_date) ? "" :
              <>
                <Icon name="calendar" />{rowDataJson ? changeFormatDate(rowDataJson.activity_start_date) === changeFormatDate(rowDataJson.activity_stop_date) ? changeFormatDate(rowDataJson.activity_start_date) : <> od {changeFormatDate(rowDataJson.activity_start_date)}  do {changeFormatDate(rowDataJson.activity_stop_date)} </> : "?"}<br />
              </>
            }
            <Icon name="marker" />{t("WidokTurnieju.lokalizacja_turnieju")} - {rowDataJson ? rowDataJson.place : "?"}<br />

          </span>
        </Segment>
        {rowDataJson && checkDateStartBeforeNow(rowDataJson.start_date) ?
          <Segment style={{paddingBottom:30}}>
            <Grid stackable >
              <Grid.Row>

                <Grid.Column width={16}>

                  <Grid textAlign='center' divided={getCountColumn() < 4 ? false : true} >
                    <Grid.Row columns={getCountColumn()} >
                      <Grid.Column style={{ padding: 10 }}>
                        <Header as='h5' icon  >
                          <Icon name='calendar' color='grey' />
                          {rowDataJson ? checkTimeExist(changeFormatDateTimeBS(rowDataJson.activity_start_date)) : "?"}
                          <HeaderSubheader>
                            {t("WidokTurnieju.rozpoczecie_turnieju")}
                          </HeaderSubheader>
                        </Header>
                      </Grid.Column>
                      <Grid.Column style={{ padding: 10 }}>
                        <Header as='h5' icon >
                          <Icon name='calendar' color='grey' />
                          {rowDataJson ? checkTimeExist(changeFormatDateTimeBS(rowDataJson.activity_stop_date)) : "?"}
                          <HeaderSubheader>
                            {t("WidokTurnieju.zakonczenie_turnieju")}
                          </HeaderSubheader>
                        </Header>
                      </Grid.Column>

                      <Grid.Column style={{ padding: 10 }}>
                        <Header as='h5' icon >
                          <Icon name='calendar' color='grey' />
                          {rowDataJson ? checkTimeExist(changeFormatDateTimeBS(rowDataJson.register_stop_date)) : "?"}
                          <HeaderSubheader>
                            {t("WidokTurnieju.koniec_zapisow")}
                          </HeaderSubheader>
                        </Header>
                      </Grid.Column>

                      <Grid.Column style={{ padding: 10 }}>
                        <Header as='h5' icon >
                          <Icon name='info circle' color='grey' />
                          {rowDataJson ? rowDataJson.organizer_name : "?"}
                          <HeaderSubheader>
                            {t("WidokTurnieju.organizator")}
                          </HeaderSubheader>
                        </Header>
                      </Grid.Column>
                      {rowDataJson && rowDataJson.organizer_email ?
                        <Grid.Column style={{ padding: 10 }}>
                          <div className='stringWrap'>
                            <Header as='h5' icon >
                              <Icon name='mail' color='grey' />

                              {rowDataJson ? rowDataJson.organizer_email : "?"}

                              <HeaderSubheader>
                                {t("WidokTurnieju.email")}
                              </HeaderSubheader>
                            </Header>
                          </div>
                        </Grid.Column>
                        : ""}
                      {rowDataJson && rowDataJson.organizer_phone ?
                        <Grid.Column style={{ padding: 10 }}>
                          <Header as='h5' icon >
                            <Icon name='phone' color='grey' />
                            {rowDataJson ? rowDataJson.organizer_phone : "?"}
                            <HeaderSubheader>
                              {t("WidokTurnieju.tel")}
                            </HeaderSubheader>
                          </Header>
                        </Grid.Column>
                        : ""}

                    </Grid.Row>
                  </Grid>

                </Grid.Column>


                {rowDataJson && rowDataJson.activity_start_date && checkDateStartBeforeNow(rowDataJson.activity_start_date) ?
                  <Grid.Column width={16} style={{ backgroundColor: authContext.darkMode ? "#2e2d2d" : "#f7f7f7", padding: 20, marginTop: 10 }}>
                    <CountDownTimer endDate={rowDataJson.activity_start_date} textValue={"Rozpoczęcie zajęć za:"} textValueFinish="" beautifulText="0" />
                  </Grid.Column>
                  : ''}

              </Grid.Row>
            </Grid>

          </Segment>
          : ""}

        {checkIsDescription() || checkIsPicture() ?
          <Segment style={{paddingBottom:30}}>
            <Grid stackable >
              <Grid.Row >
                {checkIsDescription() ?
                  <Grid.Column width={width < 1200 ? 16 : checkIsPicture() ? 9 : 16}>


                    <>

                      <Label style={{ marginBottom: 10 }} color='blue' ribbon>
                        <Icon name='sticky note' /> Opis zajęć
                      </Label><br />

                      <Markup content={rowDataJson ? rowDataJson.description : "?"} />
                    </>


                  </Grid.Column>
                  : ""
                }
                {checkIsPicture() ?
                  <Grid.Column width={width < 1200 ? 16 : checkIsDescription() ? 7 : 16} style={{ backgroundColor: authContext.darkMode ? "#2e2d2d" : width < 1000 ? "#f7f7f7" : "#f7f7f7", padding: 20 }}>
                    {width < 1000 ? "" :
                      <Label style={{ marginBottom: 10 }} color='blue' ribbon>
                        <Icon name='image' /> {t("WidokTurnieju.plakat")}
                      </Label>
                    }
                    <div className={"plakatTurniej"} onClick={() => openModal(rowDataJson ? rowDataJson.img_file : noimage)} >
                      <MyImageLazy alt="plakat" className={"plakatTurniej"} src={rowDataJson && rowDataJson.img_file ? rowDataJson.img_file : noimage} />
                    </div>
                  </Grid.Column>
                  : ""}

              </Grid.Row>
            </Grid>
          </Segment>
          : ""}


                      
        <Segment style={{ backgroundColor: authContext.darkMode ? "#2e2e2e" : "", paddingLeft: width < mobileWSmall() ? 3 : 30, paddingRight: width < mobileWSmall() ? 3 : 30 }}>
          <Grid stackable  >

            <Grid.Row  >

              <Grid.Column width={width < 1400 ? 16 : 10}  >
                <Segment >
                  <Label style={{ marginBottom: 10 }} color='blue' ribbon>
                    <Icon name='users' /> Lista uczestników
                  </Label>
                  <div style={{ overflowX: "auto", width: width < 700 ? "100%" : "100%" }} >

                    <Table inverted={authContext.darkMode} size='small' celled striped compact unstackable >
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell singleLine width={1} textAlign='center'>LP</Table.HeaderCell>
                          <Table.HeaderCell >UCZESTNIK</Table.HeaderCell>
                          <Table.HeaderCell textAlign='center'>EMAIL</Table.HeaderCell>
                          <Table.HeaderCell width={1} textAlign='center' singleLine>POTWIERDZENIE </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {rowDataJson && rowDataJson.members ?
                          rowDataJson.members.map((line2, i) =>
                            <Table.Row key={i}>
                              <Table.Cell textAlign='center'>{i + 1}</Table.Cell>
                              <Table.Cell singleLine style={{ minWidth: 250, position: "relative" }}><figure className='imgPlayer'><ShowImgAvatar urlpic={line2.member_img_file} mtype={"0"} msize={'mini'} /><figcaption>{getlinkplayerprofile(line2.member_id, line2.member_name)} </figcaption></figure> </Table.Cell>
                              <Table.Cell textAlign='center'>{line2.member_email} </Table.Cell>
                              <Table.Cell textAlign='center'>{line2.member_confirmed === 1 ? <Icon name='check' color='green' /> : <Icon name='x' color='red' />}</Table.Cell>
                            </Table.Row>
                          )
                          : <Table.Row></Table.Row>}

                      </Table.Body>


                    </Table>

                  </div>
                </Segment>
              </Grid.Column>
              <Grid.Column width={width < 1400 ? 16 : 6}  >

                <Segment>
                  <Label style={{ marginBottom: 10 }} color='blue' ribbon>
                    <Icon name='add' /> Zapisz się do zajęć
                  </Label>

                  {rowDataJson ?
                    <MyTournamentAddUsersActivity rowDataJson={rowDataJson} show_members_additional_info={rowDataJson.show_members_additional_info} count_member={rowDataJson.members.length} members_limit={rowDataJson ? rowDataJson.members_limit : 0} activity_id={props.activity_id} subTurnamentType={"USER"} registrationTournament={true} />
                    : ""}
                </Segment>




              </Grid.Column>
            </Grid.Row>
          </Grid>

        </Segment>
      </div>

  )
}

export default ShowActivities;